import { TestService } from './../proxy/tests/test.service';
import { GetTestListDto, TestDto } from './../proxy/tests/models';
import { ConfigStateService, CurrentUserDto, LocalizationService, PagedResultDto } from "@abp/ng.core";
import { Component, OnInit } from "@angular/core";
import { Constants } from '../shared/Constants/Constants';
import { Router } from '@angular/router';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserLookupDto } from '@proxy/enova-users-lookup';
import { EnovaUserLookupService } from '@proxy/enova-user-lookup';
import { provideRouteList, RouteListService } from '../shared/ExtendedListService/route-list.service';
import { TestsFilters } from './tests-filters';

@Component({
    selector: 'app-test',
    templateUrl: './tests.component.html',
    styleUrls: ['./tests.component.scss'],
    providers: [provideRouteList(TestsFilters)]
})
export class TestsComponent implements OnInit {
    tests = { items: [], totalCount: 0} as PagedResultDto<TestDto>;
    filterInput = '';
    isModalOpen = false;
    tenantId: string;
    isAdmin = false;
    hostUsers: UserLookupDto[] = [];
    
    DateTimeFormatConst = Constants.DATETIME;

    form: UntypedFormGroup;

    /** Single stable object for the page's lifetime; hydrated from / synced to the URL. */
    get filters(): GetTestListDto {
        return this.testsFilters.value;
    }

    constructor(
        public readonly list: RouteListService,
        public enovaUserLookupService: EnovaUserLookupService,
        private testAppService: TestService,
        private localizationService: LocalizationService,
        private fb: UntypedFormBuilder,
        private router: Router,
        private confirmation: ConfirmationService,
        private config: ConfigStateService,
        private testsFilters: TestsFilters,
        private toaster: ToasterService)
    { }

    ngOnInit(): void {
        const testStreamCreator = (query) => this.testAppService.getList({
            ...query,
            ...this.filters,
        });

        var currentUser = this.config.getOne("currentUser");
        if (currentUser.tenantId == null && currentUser.roles.includes("admin")) {
            this.enovaUserLookupService.getUserLookup().subscribe((response) => {
                this.hostUsers = response.items;
            })
            this.isAdmin = true;
        }

        this.list.hookToQuery(testStreamCreator).subscribe((response) => {
            this.tests.items = response.items;
            this.tests.totalCount = response.totalCount;
        });
    }

    createTest() {
        this.buildForm();
        this.isModalOpen = true;
    }

    buildForm() {
        this.form = this.fb.group({
            Name: ['', [Validators.required]],
            IdentificationNumber: ['', [Validators.required]],
            Description: ['', []]
        });
    }

    clearFilters(){
        this.testsFilters.reset();
        this.list.refreshToFirstPage();
    }

    openEditView(testId: string) {
        this.router.navigate(['tests/edit', testId]);
    }

    openTestAttemptView(testId: string){
        this.router.navigate(["test/attempt"], {queryParams: {
            id: testId
        }});
    }

    getTestAttemptFeature(): boolean {
        return this.config.getFeature("Test.Attempt") == "true";
    }
    
    getTestControlFeature(): boolean {
        return this.config.getFeature("Test.Control") == "true";
    }
    

    deleteTest(id: string) {
        this.confirmation.warn('::Test:Message:Delete:Confirmation', 'AbpAccount::AreYouSure')
            .subscribe((status) => {
                if (status === Confirmation.Status.confirm) {
                    this.testAppService.delete(id).subscribe(null, 
                        () => {
                            this.toaster.error(
                                this.localizationService.instant("::Test:Message:Delete:Error")
                            );
                        }, () => {
                            this.list.refreshAfterDelete(this.tests.totalCount!);
                            this.toaster.success( 
                                this.localizationService.instant("::Test:Message:Delete:Success")
                            );
                        }
                    );
                }
            });
    }

    save() {
        if (this.form.invalid) {
            return;
        }
    
        this.testAppService.create(this.form.value).subscribe(
            (value) => {
                this.isModalOpen = false;
                this.form.reset();
                this.list.refreshToFirstPage();
                this.router.navigate(['tests/edit', value.id]);
            }, (error) => {
                this.toaster.error(
                    this.localizationService.instant("::Test:Message:Created:Error")
                );
            }, () => {
                this.toaster.success( 
                    this.localizationService.instant("::Test:Message:Created:Success")
                );
            }
        );
    }
}